export default {
  zh: {
    home: "首页",
    chat: '聊天',
    image: '图片',
    video: '视频',
    character: '角色',
    music: '音乐',
    video_effects: '视频特效',
    image_effects: '图片特效',
    all_tools: '编辑工具',
    blog: '博客',
    API: 'API',
    expert: '专家',
    image_tools: '图片工具',
    video_tools: '视频工具',
    image_models: '图片模型',
    video_models: '视频模型',
    join_vip: '加入 VIP',
    enjoy_more_benefits: '享更多权益',
    history: '历史记录',
    recently_used: '最近使用',
    record: '记录',
    kling30: '电影级画面，原生音频。',
    seedance20: '导演级控制、角色一致、口型同步。',
    viduq3: '原生 16 秒音视频，智能剪辑。',
    image_effects_desc: '同步高质量的图片特效',
    video_effects_desc: '同步高质量的视频特效',
    music_inspiration: '音乐灵感',
    music_inspiration_desc: '同步高质量的音乐灵感',
    my_images: '我的图片',
    my_videos: '我的视频',
    my_music: '我的音乐',
    view_my_creations: '查看我的作品',
    app_download: '下载 WeryAI APP',
    app_download_desc: '海量模型，等你探索',
    download_on: '下载至',
    daily_reward_unpaid: 'VIP 每日赠 {count} 积分',
    daily_reward_paid: '每日积分奖励 {count}',
    daily_reward_unpaid_short: 'VIP赠{count}积分/天',
    daily_reward_paid_short: '{plan} 赠{count}积分/日',
    credits_label: '积分',
    vip_daily_credits_label: '每日奖励',
    plan_daily_credits_label: '{plan}+每日奖励',
    usage_details: '用量明细',
  },
  en: {
    home: 'Home',
    chat: 'Chat',
    image: 'Image',
    video: 'Video',
    character: 'Characters',
    music: 'Music',
    video_effects: 'Video Effects',
    image_effects: 'Image Effects',
    all_tools: 'Editor Toolkits',
    blog: 'Blog',
    API: 'API',
    expert: 'Expert',
    image_tools: 'Image Tools',
    video_tools: 'Video Tools',
    image_models: 'Image Models',
    video_models: 'Video Models',
    join_vip: 'Join VIP',
    enjoy_more_benefits: 'Enjoy more benefits',
    history: 'History',
    recently_used: 'Recently Used',
    record: 'Records',
    kling30: 'Cinematic visuals with native audio.',
    seedance20: 'Director control, consistent characters, lip-sync.',
    viduq3: 'Native 16s audio-video with smart cuts.',
    image_effects_desc: 'High-quality images with sync effects',
    video_effects_desc: 'High-quality video with sync effects',
    music_inspiration: 'Music Inspiration',
    music_inspiration_desc: 'High-quality music inspiration with sync',
    my_images: 'My Images',
    my_videos: 'My Videos',
    my_music: 'My Music',
    view_my_creations: 'View My Creations',
    app_download: 'Download WeryAI APP',
    app_download_desc: 'Tons of models await your exploration',
    download_on: 'Download on',
    daily_reward_unpaid: 'VIP daily gift {count} credits',
    daily_reward_paid: 'Daily credit reward {count}',
    daily_reward_unpaid_short: 'VIP {count}/day',
    daily_reward_paid_short: '{plan} {count} credits/day',
    credits_label: 'Credits',
    vip_daily_credits_label: 'Daily Reward',
    plan_daily_credits_label: '{plan} + Daily Reward',
    usage_details: 'Usage details',
  },
  ja: {
    home: 'ホーム',
    chat: 'チャット',
    image: '画像',
    video: '動画',
    character: 'キャラ',
    music: '音楽',
    video_effects: '動画効果 ',
    image_effects: '画像効果',
    all_tools: 'ツール',
    blog: 'ブログ',
    API: 'API',
    expert: 'エキスパート',
    image_tools: '画像ツール',
    video_tools: '動画ツール',
    image_models: '画像モデル',
    video_models: '動画モデル',
    join_vip: 'VIP登録',
    enjoy_more_benefits: '特典をもっと',
    history: '履歴',
    recently_used: '最近使用',
    record: '記錄',
    kling30: '映画級の映像、ネイティブ音声。',
    seedance20: '監督級コントロール、キャラ一貫性、リップシンク。',
    viduq3: 'ネイティブ16秒の音声付き動画、スマートカット。',
    image_effects_desc: '高品質な画像効果を同期',
    video_effects_desc: '高品質な動画効果を同期',
    music_inspiration: '音楽インスピレーション',
    music_inspiration_desc: '高品質な音楽インスピレーションを同期',
    my_images: '私の画像',
    my_videos: '私の動画',
    my_music: '私の音楽',
    view_my_creations: '自分の作品を見る',
    app_download: 'WeryAI APP をダウンロード',
    app_download_desc: 'たくさんのモデルがあなたの探索を待っています',
    download_on: 'こちらからダウンロード',
    daily_reward_unpaid: 'VIP 毎日ギフト {count} クレジット',
    daily_reward_paid: '毎日クレジット報酬 {count}',
    daily_reward_unpaid_short: 'VIP {count}/日',
    daily_reward_paid_short: '{plan} {count}クレジット/日',
    credits_label: 'クレジット',
    vip_daily_credits_label: '毎日の報酬',
    plan_daily_credits_label: '{plan}+毎日の報酬',
    usage_details: '利用明細',
  },
  ko: {
    home: '홈',
    chat: '채팅',
    image: '이미지',
    video: '비디오',
    character: '캐릭터',
    music: '음악',
    video_effects: '비디오 효과',
    image_effects: '이미지 효과',
    all_tools: '편집 도구',
    API: 'API',
    expert: '전문가',
    image_tools: '이미지 도구',
    video_tools: '비디오 도구',
    image_models: '이미지 모델',
    video_models: '비디오 모델',
    join_vip: 'VIP 가입',
    enjoy_more_benefits: '더 많은 혜택을 누리세요',
    history: '기록',
    recently_used: '최근 사용',
    record: '기록',
    kling30: '시네마틱 비주얼, 네이티브 오디오.',
    seedance20: '감독급 제어, 캐릭터 일관성, 립싱크.',
    viduq3: '네이티브 16초 오디오-비디오, 스마트 컷.',
    image_effects_desc: '고품질 이미지 효과를 동기화',
    video_effects_desc: '고품질 비디오 효과를 동기화',
    music_inspiration: '음악 영감',
    music_inspiration_desc: '고품질 음악 영감을 동기화',
    my_images: '내 이미지',
    my_videos: '내 비디오',
    my_music: '내 음악',
    view_my_creations: '내 작품 보기',
    app_download: 'WeryAI APP 다운로드',
    app_download_desc: '다양한 모델이 당신의 탐색을 기다립니다',
    download_on: '에서 다운로드',
    daily_reward_unpaid: 'VIP 매일 선물 {count} 크레딧',
    daily_reward_paid: '매일 크레딧 보상 {count}',
    daily_reward_unpaid_short: 'VIP {count}/일',
    daily_reward_paid_short: '{plan} {count}크레딧/일',
    credits_label: '크레딧',
    vip_daily_credits_label: '일일 보상',
    plan_daily_credits_label: '{plan}+일일 보상',
    usage_details: '사용 내역',
  },
  tw: {
    home: '首頁',
    chat: '聊天',
    image: '圖片',
    video: '影片',
    character: '角色',
    music: '音樂',
    video_effects: '影片特效',
    image_effects: '圖片特效',
    all_tools: '編輯工具',
    API: 'API',
    expert: '專家',
    image_tools: '圖片工具',
    video_tools: '影片工具',
    image_models: '圖片模型',
    video_models: '影片模型',
    join_vip: '加入 VIP',
    enjoy_more_benefits: '享更多權益',
    history: '歷史記錄',
    recently_used: '最近使用',
    record: '記錄',
    kling30: '電影級畫面、原生音訊。',
    seedance20: '導演級控制、角色一致、口型同步。',
    viduq3: '原生 16 秒音視訊、智慧剪輯。',
    image_effects_desc: '同步高品質的圖片特效',
    video_effects_desc: '同步高品質的影片特效',
    music_inspiration: '音樂靈感',
    music_inspiration_desc: '同步高品質的音樂靈感',
    my_images: '我的圖片',
    my_videos: '我的影片',
    my_music: '我的音樂',
    view_my_creations: '查看我的作品',
    app_download: '下載 WeryAI APP',
    app_download_desc: '海量模型，等你探索',
    download_on: '下載至',
    daily_reward_unpaid: 'VIP 每日贈 {count} 積分',
    daily_reward_paid: '每日積分獎勵 {count}',
    daily_reward_unpaid_short: 'VIP贈{count}積分/天',
    daily_reward_paid_short: '{plan} 贈{count}積分/日',
    credits_label: '積分',
    vip_daily_credits_label: '每日獎勵',
    plan_daily_credits_label: '{plan}+每日獎勵',
    usage_details: '用量明細',
  },
  es: {
    home: 'Inicio',
    chat: 'Chat',
    image: 'Imagen',
    video: 'Vídeo',
    character: 'Personajes',
    music: 'Música',
    video_effects: 'Efectos de vídeo',
    image_effects: 'Efectos de imagen',
    all_tools: 'Herramientas de edición',
    API: 'API',
    expert: 'Experto',
    image_tools: 'Herramientas de imagen',
    video_tools: 'Herramientas de vídeo',
    image_models: 'Modelos de imagen',
    video_models: 'Modelos de vídeo',
    join_vip: 'Únete a VIP',
    enjoy_more_benefits: 'Disfruta más beneficios',
    history: 'Historial',
    recently_used: 'Recientemente utilizado',
    record: 'Registro',
    kling30: 'Visuales cinematográficos y audio nativo.',
    seedance20: 'Control de director, personajes consistentes, sincronización labial.',
    viduq3: 'Audio‑vídeo nativo de 16 s con cortes inteligentes.',
    image_effects_desc: 'Efectos de imagen de alta calidad sincronizados',
    video_effects_desc: 'Efectos de vídeo de alta calidad sincronizados',
    music_inspiration: 'Inspiración musical',
    music_inspiration_desc: 'Inspiración musical de alta calidad sincronizada',
    my_images: 'Mis imágenes',
    my_videos: 'Mis videos',
    my_music: 'Mi música',
    view_my_creations: 'Ver mis creaciones',
    app_download: 'Descargar WeryAI APP',
    app_download_desc: 'Muchos modelos esperan tu exploración',
    download_on: 'Descargar en',
    daily_reward_unpaid: 'VIP regalo diario {count} créditos',
    daily_reward_paid: 'Recompensa diaria {count}',
    daily_reward_unpaid_short: 'VIP {count}/día',
    daily_reward_paid_short: '{plan} {count} créditos/día',
    credits_label: 'Créditos',
    vip_daily_credits_label: 'Recompensa diaria',
    plan_daily_credits_label: '{plan} + recompensa diaria',
    usage_details: 'Detalle de uso',
  },
  fr: {
    home: 'Accueil',
    chat: 'Chat',
    image: 'Image',
    video: 'Vidéo',
    character: 'Personnages',
    music: 'Musique',
    video_effects: 'Effets vidéo',
    image_effects: 'Effets image',
    all_tools: 'Outils d\'édition',
    API: 'API',
    expert: 'Expert',
    image_tools: 'Outils d\'image',
    video_tools: 'Outils vidéo',
    image_models: 'Modèles d\'image',
    video_models: 'Modèles vidéo',
    join_vip: 'Rejoindre VIP',
    enjoy_more_benefits: 'Profitez de plus d\'avantages',
    history: 'Historique',
    recently_used: 'Récemment utilisé',
    record: 'Enregistrement',
    kling30: 'Visuels cinématographiques, audio natif.',
    seedance20: 'Contrôle de réalisateur, personnages cohérents, synchro labiale.',
    viduq3: 'Audio‑vidéo natif 16 s, coupes intelligentes.',
    image_effects_desc: 'Effets d’image haute qualité synchronisés',
    video_effects_desc: 'Effets vidéo haute qualité synchronisés',
    music_inspiration: 'Inspiration musicale',
    music_inspiration_desc: 'Inspiration musicale de haute qualité synchronisée',
    my_images: 'Mes images',
    my_videos: 'Mes vidéos',
    my_music: 'Ma musique',
    view_my_creations: 'Voir mes créations',
    app_download: 'Télécharger WeryAI APP',
    app_download_desc: 'Une multitude de modèles vous attendent',
    download_on: 'Télécharger sur',
    daily_reward_unpaid: 'VIP cadeau quotidien {count} crédits',
    daily_reward_paid: 'Récompense quotidienne {count}',
    daily_reward_unpaid_short: 'VIP {count}/jour',
    daily_reward_paid_short: '{plan} {count} crédits/jour',
    credits_label: 'Crédits',
    vip_daily_credits_label: 'Récompense quotidienne',
    plan_daily_credits_label: '{plan} + récompense quotidienne',
    usage_details: "Détails d'utilisation",
  },
  de: {
    home: 'Startseite',
    chat: 'Chat',
    image: 'Bild',
    video: 'Video',
    character: 'Charaktere',
    music: 'Musik',
    video_effects: 'Videoeffekte',
    image_effects: 'Bildeffekte',
    all_tools: 'Editor-Tools',
    API: 'API',
    expert: 'Experte',
    image_tools: 'Bildwerkzeuge',
    video_tools: 'Videowerkzeuge',
    image_models: 'Bildmodelle',
    video_models: 'Videomodelle',
    join_vip: 'VIP beitreten',
    enjoy_more_benefits: 'Mehr Vorteile genießen',
    history: 'Verlauf',
    recently_used: 'Kürzlich verwendet',
    record: 'Aufzeichnung',
    kling30: 'Kinoreife Bilder, natives Audio.',
    seedance20: 'Regie‑Kontrolle, konsistente Charaktere, Lip‑Sync.',
    viduq3: 'Natives 16‑s Audio‑Video, smarte Schnitte.',
    image_effects_desc: 'Synchronisierte Bildeffekte in hoher Qualität',
    video_effects_desc: 'Synchronisierte Videoeffekte in hoher Qualität',
    music_inspiration: 'Musik-Inspiration',
    music_inspiration_desc: 'Synchronisierte Musik-Inspiration in hoher Qualität',
    my_images: 'Meine Bilder',
    my_videos: 'Meine Videos',
    my_music: 'Meine Musik',
    view_my_creations: 'Meine Kreationen ansehen',
    app_download: 'WeryAI APP herunterladen',
    app_download_desc: 'Zahlreiche Modelle warten auf Ihre Erkundung',
    download_on: 'Herunterladen im',
    daily_reward_unpaid: 'VIP tägliches Geschenk {count} Credits',
    daily_reward_paid: 'Tägliche Credit-Belohnung {count}',
    daily_reward_unpaid_short: 'VIP {count}/Tag',
    daily_reward_paid_short: '{plan} {count} Credits/Tag',
    credits_label: 'Credits',
    vip_daily_credits_label: 'Tägliche Belohnung',
    plan_daily_credits_label: '{plan} + tägliche Belohnung',
    usage_details: 'Nutzungsdetails',
  },
  ru: {
    home: 'Главная',
    chat: 'Чат',
    image: 'Изображение',
    video: 'Видео',
    character: 'Персонажи',
    music: 'Музыка',
    video_effects: 'Видеоэффекты',
    image_effects: 'Эффекты изображений',
    all_tools: 'Инструменты редактора',
    API: 'API',
    expert: 'Эксперт',
    image_tools: 'Инструменты изображений',
    video_tools: 'Видеоинструменты',
    image_models: 'Модели изображений',
    video_models: 'Видеомодели',
    join_vip: 'Присоединиться к VIP',
    enjoy_more_benefits: 'Больше преимуществ',
    history: 'История',
    recently_used: 'Недавно использовано',
    record: 'Запись',
    kling30: 'Кинематографично, нативный звук.',
    seedance20: 'Режиссёрский контроль, стабильные персонажи, лип‑синк.',
    viduq3: 'Нативное 16‑сек. аудио‑видео, умные склейки.',
    image_effects_desc: 'Синхронизированные эффекты изображений высокого качества',
    video_effects_desc: 'Синхронизированные видеоэффекты высокого качества',
    music_inspiration: 'Музыкальное вдохновение',
    music_inspiration_desc: 'Синхронизированное музыкальное вдохновение высокого качества',
    my_images: 'Мои изображения',
    my_videos: 'Мои видео',
    my_music: 'Моя музыка',
    view_my_creations: 'Посмотреть мои работы',
    app_download: 'Скачать WeryAI APP',
    app_download_desc: 'Вас ждёт множество моделей для изучения',
    download_on: 'Скачать в',
    daily_reward_unpaid: 'VIP ежедневный подарок {count}',
    daily_reward_paid: 'Ежедневная награда {count}',
    daily_reward_unpaid_short: 'VIP {count}/день',
    daily_reward_paid_short: '{plan} {count} кредитов/день',
    credits_label: 'Кредиты',
    vip_daily_credits_label: 'Ежедневная награда',
    plan_daily_credits_label: '{plan} + ежедневная награда',
    usage_details: 'Детали использования',
  },
  pt: {
    home: 'Главная',
    chat: 'Чат',
    image: 'Фото',
    video: 'Видео',
    character: 'Персонажи',
    music: 'Музыка',
    video_effects: 'Видео FX',
    image_effects: 'Фото FX',
    all_tools: 'Ferramentas de edição',
    API: 'Инструменты',
    expert: 'Especialista',
    image_tools: 'Ferramentas de imagem',
    video_tools: 'Ferramentas de vídeo',
    image_models: 'Modelos de imagem',
    video_models: 'Modelos de vídeo',
    join_vip: 'Junte-se ao VIP',
    enjoy_more_benefits: 'Aproveite mais benefícios',
    history: 'Histórico',
    recently_used: 'Recentemente utilizado',
    record: 'Registro',
    kling30: 'Visuais cinematográficos e áudio nativo.',
    seedance20: 'Controle de diretor, personagens consistentes, lip-sync.',
    viduq3: 'Áudio‑vídeo nativo de 16 s com cortes inteligentes.',
    image_effects_desc: 'Efeitos de imagem de alta qualidade sincronizados',
    video_effects_desc: 'Efeitos de vídeo de alta qualidade sincronizados',
    music_inspiration: 'Inspiração musical',
    music_inspiration_desc: 'Inspiração musical de alta qualidade sincronizada',
    my_images: 'Minhas imagens',
    my_videos: 'Meus vídeos',
    my_music: 'Minha música',
    view_my_creations: 'Ver minhas criações',
    app_download: 'Baixar WeryAI APP',
    app_download_desc: 'Muitos modelos aguardam sua exploração',
    download_on: 'Baixar na',
    daily_reward_unpaid: 'VIP presente diário {count} créditos',
    daily_reward_paid: 'Recompensa diária {count}',
    daily_reward_unpaid_short: 'VIP {count}/dia',
    daily_reward_paid_short: '{plan} {count} créditos/dia',
    credits_label: 'Créditos',
    vip_daily_credits_label: 'Recompensa diária',
    plan_daily_credits_label: '{plan} + recompensa diária',
    usage_details: 'Detalhes de uso',
  },
  it: {
    home: 'Home',
    chat: 'Chat',
    image: 'Immagine',
    video: 'Video',
    character: 'Personaggi',
    music: 'Musica',
    video_effects: 'Effetti video',
    image_effects: 'Effetti immagine',
    all_tools: 'Strumenti di editing',
    API: 'API',
    expert: 'Esperto',
    image_tools: 'Strumenti immagine',
    video_tools: 'Strumenti video',
    image_models: 'Modelli immagine',
    video_models: 'Modelli video',
    join_vip: 'Unisciti a VIP',
    enjoy_more_benefits: 'Goditi più vantaggi',
    history: 'Cronologia',
    recently_used: 'Recente utilizzato',
    record: 'Registrazione',
    kling30: 'Visivi cinematografici e audio nativo.',
    seedance20: 'Controllo da regista, personaggi coerenti, lip-sync.',
    viduq3: 'Audio‑video nativo 16 s con tagli intelligenti.',
    image_effects_desc: 'Effetti immagine di alta qualità sincronizzati',
    video_effects_desc: 'Effetti video di alta qualità sincronizzati',
    music_inspiration: 'Ispirazione musicale',
    music_inspiration_desc: 'Ispirazione musicale di alta qualità sincronizzata',
    my_images: 'Le mie immagini',
    my_videos: 'I miei video',
    my_music: 'La mia musica',
    view_my_creations: 'Visualizza le mie creazioni',
    app_download: 'Scarica WeryAI APP',
    app_download_desc: 'Tantissimi modelli ti aspettano',
    download_on: 'Scarica su',
    daily_reward_unpaid: 'VIP regalo giornaliero {count} crediti',
    daily_reward_paid: 'Ricompensa giornaliera {count}',
    daily_reward_unpaid_short: 'VIP {count}/giorno',
    daily_reward_paid_short: '{plan} {count} crediti/giorno',
    credits_label: 'Crediti',
    vip_daily_credits_label: 'Ricompensa giornaliera',
    plan_daily_credits_label: '{plan} + ricompensa giornaliera',
    usage_details: 'Dettagli utilizzo',
  },
  ar: {
    home: 'الرئيسية',
    chat: 'دردشة',
    image: 'صورة',
    video: 'فيديو',
    character: 'شخصيات',
    music: 'موسيقى',
    video_effects: 'مؤثرات الفيديو',
    image_effects: 'مؤثرات الصور',
    all_tools: 'أدوات التحرير',
    API: 'API',
    expert: 'خبير',
    image_tools: 'أدوات الصور',
    video_tools: 'أدوات الفيديو',
    image_models: 'نماذج الصور',
    video_models: 'نماذج الفيديو',
    join_vip: 'انضم إلى VIP',
    enjoy_more_benefits: 'استمتع بمزيد من المزايا',
    history: 'السجل',
    recently_used: 'أحدث استخدام',
    record: 'سجل',
    kling30: 'مرئيات سينمائية وصوت أصلي.',
    seedance20: 'تحكم بمستوى المخرج، شخصيات متسقة، مزامنة الشفاه.',
    viduq3: 'فيديو بصوت أصلي 16 ثانية مع قطوع ذكية.',
    image_effects_desc: 'تأثيرات صور عالية الجودة مع مزامنة',
    video_effects_desc: 'تأثيرات فيديو عالية الجودة مع مزامنة',
    music_inspiration: 'إلهام موسيقي',
    music_inspiration_desc: 'إلهام موسيقي عالي الجودة مع مزامنة',
    my_images: 'صوري',
    my_videos: 'فيديوهاتي',
    my_music: 'موسيقاي',
    view_my_creations: 'عرض أعمالي',
    app_download: 'تنزيل WeryAI APP',
    app_download_desc: 'العديد من النماذج بانتظار استكشافك',
    download_on: 'تنزيل على',
    daily_reward_unpaid: 'هدية VIP اليومية {count}',
    daily_reward_paid: 'مكافأة يومية {count}',
    daily_reward_unpaid_short: 'VIP {count}/يوم',
    daily_reward_paid_short: '{plan} {count} رصيد/يوم',
    credits_label: 'الرصيد',
    vip_daily_credits_label: 'مكافأة يومية',
    plan_daily_credits_label: '{plan} + مكافأة يومية',
    usage_details: 'تفاصيل الاستخدام',
  },
  th: {
    home: 'หน้าแรก',
    chat: 'แชท',
    image: 'รูปภาพ',
    video: 'วิดีโอ',
    character: 'ตัวละคร',
    music: 'เพลง',
    video_effects: 'เอฟเฟกต์วิดีโอ',
    image_effects: 'เอฟเฟกต์รูปภาพ',
    all_tools: 'เครื่องมือแก้ไข',
    API: 'API',
    expert: 'ผู้เชี่ยวชาญ',
    image_tools: 'เครื่องมือรูปภาพ',
    video_tools: 'เครื่องมือวิดีโอ',
    image_models: 'โมเดลรูปภาพ',
    video_models: 'โมเดลวิดีโอ',
    join_vip: 'เข้าร่วม VIP',
    enjoy_more_benefits: 'รับสิทธิประโยชน์มากขึ้น',
    history: 'ประวัติ',
    recently_used: 'ล่าสุดใช้งาน',
    record: 'บันทึก',
    kling30: 'ภาพสไตล์ภาพยนตร์ พร้อมเสียงเนทีฟ',
    seedance20: 'ควบคุมระดับผู้กำกับ ตัวละครคงที่ ลิปซิงก์',
    viduq3: 'วิดีโอพร้อมเสียงเนทีฟ 16 วิ พร้อมการตัดต่ออัจฉริยะ',
    image_effects_desc: 'เอฟเฟกต์รูปภาพคุณภาพสูงแบบซิงก์',
    video_effects_desc: 'เอฟเฟกต์วิดีโอคุณภาพสูงแบบซิงก์',
    music_inspiration: 'แรงบันดาลใจด้านดนตรี',
    music_inspiration_desc: 'แรงบันดาลใจด้านดนตรีคุณภาพสูงแบบซิงก์',
    my_images: 'รูปภาพของฉัน',
    my_videos: 'วิดีโอของฉัน',
    my_music: 'เพลงของฉัน',
    view_my_creations: 'ดูผลงานของฉัน',
    app_download: 'ดาวน์โหลด WeryAI APP',
    app_download_desc: 'มีโมเดลมากมายรอให้คุณสำรวจ',
    download_on: 'ดาวน์โหลดบน',
    daily_reward_unpaid: 'VIP ของขวัญรายวัน {count}',
    daily_reward_paid: 'รางวัลเครดิตรายวัน {count}',
    daily_reward_unpaid_short: 'VIP {count}/วัน',
    daily_reward_paid_short: '{plan} {count} เครดิต/วัน',
    credits_label: 'เครดิต',
    vip_daily_credits_label: 'รางวัลรายวัน',
    plan_daily_credits_label: '{plan} + รางวัลรายวัน',
    usage_details: 'รายละเอียดการใช้งาน',
  },
  id: {
    home: 'Beranda',
    chat: 'Obrolan',
    image: 'Gambar',
    video: 'Video',
    character: 'Karakter',
    music: 'Musik',
    video_effects: 'Efek Video',
    image_effects: 'Efek Gambar',
    all_tools: 'Alat Editor',
    API: 'API',
    expert: 'Ahli',
    image_tools: 'Alat Gambar',
    video_tools: 'Alat Video',
    image_models: 'Model Gambar',
    video_models: 'Model Video',
    join_vip: 'Gabung VIP',
    enjoy_more_benefits: 'Nikmati lebih banyak keuntungan',
    history: 'Riwayat',
    recently_used: 'Terakhir digunakan',
    record: 'Catatan',
    kling30: 'Visual sinematik, audio native.',
    seedance20: 'Kontrol sutradara, karakter konsisten, lip-sync.',
    viduq3: 'Audio‑video native 16 dtk, potongan cerdas.',
    image_effects_desc: 'Efek gambar berkualitas tinggi dengan sinkronisasi',
    video_effects_desc: 'Efek video berkualitas tinggi dengan sinkronisasi',
    music_inspiration: 'Inspirasi musik',
    music_inspiration_desc: 'Inspirasi musik berkualitas tinggi dengan sinkronisasi',
    my_images: 'Gambar Saya',
    my_videos: 'Video Saya',
    my_music: 'Musik Saya',
    view_my_creations: 'Lihat Karya Saya',
    app_download: 'Unduh WeryAI APP',
    app_download_desc: 'Banyak model menunggu untuk Anda jelajahi',
    download_on: 'Unduh di',
    daily_reward_unpaid: 'Hadiah harian VIP {count}',
    daily_reward_paid: 'Hadiah kredit harian {count}',
    daily_reward_unpaid_short: 'VIP {count}/hari',
    daily_reward_paid_short: '{plan} {count} kredit/hari',
    credits_label: 'Kredit',
    vip_daily_credits_label: 'Hadiah harian',
    plan_daily_credits_label: '{plan} + hadiah harian',
    usage_details: 'Detail penggunaan',
  },
  tr: {
    home: 'Ana Sayfa',
    chat: 'Sohbet',
    image: 'Görsel',
    video: 'Video',
    character: 'Karakterler',
    music: 'Müzik',
    video_effects: 'Video Efektleri',
    image_effects: 'Görsel Efektleri',
    all_tools: 'Düzenleme Araçları',
    API: 'API',
    expert: 'Uzman',
    image_tools: 'Görsel Araçları',
    video_tools: 'Video Araçları',
    image_models: 'Görsel Modelleri',
    video_models: 'Video Modelleri',
    join_vip: 'VIP\'e Katıl',
    enjoy_more_benefits: 'Daha fazla avantajın keyfini çıkar',
    history: 'Geçmiş',
    recently_used: 'Son kullanılan',
    record: 'Notlar',
    kling30: 'Sinematik görseller, yerel ses.',
    seedance20: 'Yönetmen kontrolü, tutarlı karakterler, dudak senkronu.',
    viduq3: 'Yerel 16 sn sesli video, akıllı kesmeler.',
    image_effects_desc: 'Senkronize yüksek kaliteli görsel efektler',
    video_effects_desc: 'Senkronize yüksek kaliteli video efektleri',
    music_inspiration: 'Müzik ilhamı',
    music_inspiration_desc: 'Senkronize yüksek kaliteli müzik ilhamı',
    my_images: 'Görsellerim',
    my_videos: 'Videolarım',
    my_music: 'Müziğim',
    view_my_creations: 'Çalışmalarımı Gör',
    app_download: 'WeryAI APP indir',
    app_download_desc: 'Keşfetmeniz için birçok model sizi bekliyor',
    download_on: 'Şuradan indir',
    daily_reward_unpaid: 'VIP günlük hediye {count}',
    daily_reward_paid: 'Günlük kredi ödülü {count}',
    daily_reward_unpaid_short: 'VIP {count}/gün',
    daily_reward_paid_short: '{plan} {count} kredi/gün',
    credits_label: 'Kredi',
    vip_daily_credits_label: 'Günlük ödül',
    plan_daily_credits_label: '{plan} + günlük ödül',
    usage_details: 'Kullanım detayları',
  },
  pl: {
    home: 'Strona główna',
    chat: 'Czat',
    image: 'Obraz',
    video: 'Wideo',
    character: 'Postacie',
    music: 'Muzyka',
    video_effects: 'Efekty wideo',
    image_effects: 'Efekty obrazu',
    all_tools: 'Narzędzia edycji',
    API: 'API',
    expert: 'Ekspert',
    image_tools: 'Narzędzia obrazu',
    video_tools: 'Narzędzia wideo',
    image_models: 'Modele obrazu',
    video_models: 'Modele wideo',
    join_vip: 'Dołącz do VIP',
    enjoy_more_benefits: 'Ciesz się większymi korzyściami',
    history: 'Historia',
    recently_used: 'Ostatnio używane',
    record: 'Notatki',
    kling30: 'Kinowe wizualizacje i natywny dźwięk.',
    seedance20: 'Kontrola reżyserska, spójne postacie, lip‑sync.',
    viduq3: 'Natywne 16 s audio‑wideo z inteligentnymi cięciami.',
    image_effects_desc: 'Synchronizowane efekty obrazu wysokiej jakości',
    video_effects_desc: 'Synchronizowane efekty wideo wysokiej jakości',
    music_inspiration: 'Inspiracje muzyczne',
    music_inspiration_desc: 'Synchronizowane inspiracje muzyczne wysokiej jakości',
    my_images: 'Moje obrazy',
    my_videos: 'Moje filmy',
    my_music: 'Moja muzyka',
    view_my_creations: 'Zobacz moje prace',
    app_download: 'Pobierz WeryAI APP',
    app_download_desc: 'Mnóstwo modeli czeka na Twoje odkrycie',
    download_on: 'Pobierz z',
    daily_reward_unpaid: 'VIP codzienny prezent {count}',
    daily_reward_paid: 'Codzienna nagroda {count}',
    daily_reward_unpaid_short: 'VIP {count}/dzień',
    daily_reward_paid_short: '{plan} {count} kredytów/dzień',
    credits_label: 'Kredyty',
    vip_daily_credits_label: 'Codzienna nagroda',
    plan_daily_credits_label: '{plan} + codzienna nagroda',
    usage_details: 'Szczegóły użycia',
  },
  da: {
    home: 'Hjem',
    chat: 'Chat',
    image: 'Billede',
    video: 'Video',
    character: 'Karakterer',
    music: 'Musik',
    video_effects: 'Videoeffekter',
    image_effects: 'Billedeffekter',
    all_tools: 'Redigeringsværktøjer',
    API: 'API',
    expert: 'Ekspert',
    image_tools: 'Billedværktøjer',
    video_tools: 'Videoværktøjer',
    image_models: 'Billedmodeller',
    video_models: 'Videomodeller',
    join_vip: 'Bliv VIP',
    enjoy_more_benefits: 'Nyd flere fordele',
    history: 'Historikk',
    recently_used: 'Sist nylig brukt',
    record: 'Notater',
    kling30: 'Filmiske billeder, indbygget lyd.',
    seedance20: 'Instruktørkontrol, konsistente karakterer, lip-sync.',
    viduq3: 'Native 16 sek. lyd‑video med smarte klip.',
    image_effects_desc: 'Synkroniserede billedeffekter i høj kvalitet',
    video_effects_desc: 'Synkroniserede videoeffekter i høj kvalitet',
    music_inspiration: 'Musik-inspiration',
    music_inspiration_desc: 'Synkroniseret musik-inspiration i høj kvalitet',
    my_images: 'Mine billeder',
    my_videos: 'Mine videoer',
    my_music: 'Min musik',
    view_my_creations: 'Se mine værker',
    app_download: 'Download WeryAI APP',
    app_download_desc: 'Masser af modeller venter på, at du udforsker dem',
    download_on: 'Download fra',
    daily_reward_unpaid: 'VIP daglig gave {count}',
    daily_reward_paid: 'Daglig kreditbelønning {count}',
    daily_reward_unpaid_short: 'VIP {count}/dag',
    daily_reward_paid_short: '{plan} {count} kreditter/dag',
    credits_label: 'Kreditter',
    vip_daily_credits_label: 'Daglig belønning',
    plan_daily_credits_label: '{plan} + daglig belønning',
    usage_details: 'Forbrugsdetaljer',
  },
  no: {
    home: 'Hjem',
    chat: 'Chat',
    image: 'Bilde',
    video: 'Video',
    character: 'Karakterer',
    music: 'Musikk',
    video_effects: 'Videoeffekter',
    image_effects: 'Bildeeffekter',
    all_tools: 'Redigeringsverktøy',
    API: 'API',
    expert: 'Ekspert',
    image_tools: 'Bildeverktøy',
    video_tools: 'Videoverktøy',
    image_models: 'Bildemodeller',
    video_models: 'Videomodeller',
    join_vip: 'Bli VIP',
    enjoy_more_benefits: 'Nyt flere fordeler',
    history: 'Historikk',
    recently_used: 'Sist nylig brukt',
    record: 'Notater',
    kling30: 'Filmatiske bilder, innebygd lyd.',
    seedance20: 'Regissørkontroll, konsistente karakterer, leppesynk.',
    viduq3: 'Native 16 sek. lyd‑video med smarte klipp.',
    image_effects_desc: 'Synkroniserte bildeeffekter i høy kvalitet',
    video_effects_desc: 'Synkroniserte videoeffekter i høy kvalitet',
    music_inspiration: 'Musikkinspirasjon',
    music_inspiration_desc: 'Synkronisert musikkinspirasjon i høy kvalitet',
    my_images: 'Mine bilder',
    my_videos: 'Mine videoer',
    my_music: 'Min musikk',
    view_my_creations: 'Se mine verk',
    app_download: 'Last ned WeryAI APP',
    app_download_desc: 'Mange modeller venter på at du skal utforske dem',
    download_on: 'Last ned fra',
    daily_reward_unpaid: 'VIP daglig gave {count}',
    daily_reward_paid: 'Daglig kredittbelønning {count}',
    daily_reward_unpaid_short: 'VIP {count}/dag',
    daily_reward_paid_short: '{plan} {count} credits/dag',
    credits_label: 'Credits',
    vip_daily_credits_label: 'Daglig belønning',
    plan_daily_credits_label: '{plan} + daglig belønning',
    usage_details: 'Bruksdetaljer',
  },
  nl: {
    home: 'Home',
    chat: 'Chat',
    image: 'Afbeelding',
    video: 'Video',
    character: 'Karakters',
    music: 'Muziek',
    video_effects: 'Video-effecten',
    image_effects: 'Afbeeldingseffecten',
    all_tools: 'Bewerkingstools',
    API: 'API',
    expert: 'Expert',
    image_tools: 'Afbeeldingstools',
    video_tools: 'Videotools',
    image_models: 'Afbeeldingsmodellen',
    video_models: 'Videomodellen',
    join_vip: 'Word VIP',
    enjoy_more_benefits: 'Geniet van meer voordelen',
    history: 'Geschiedenis',
    recently_used: 'Onlangs gebruikt',
    record: 'Notities',
    kling30: 'Cinematische beelden en native audio.',
    seedance20: 'Regisseurscontrole, consistente personages, lipsync.',
    viduq3: 'Native 16s audio‑video met slimme cuts.',
    image_effects_desc: 'Gesynchroniseerde afbeeldingseffecten van hoge kwaliteit',
    video_effects_desc: 'Gesynchroniseerde video-effecten van hoge kwaliteit',
    music_inspiration: 'Muzikale inspiratie',
    music_inspiration_desc: 'Gesynchroniseerde muzikale inspiratie van hoge kwaliteit',
    my_images: 'Mijn afbeeldingen',
    my_videos: 'Mijn video\'s',
    my_music: 'Mijn muziek',
    view_my_creations: 'Bekijk mijn creaties',
    app_download: 'Download WeryAI APP',
    app_download_desc: 'Talloze modellen wachten erop om door jou ontdekt te worden',
    download_on: 'Download op',
    daily_reward_unpaid: 'VIP dagelijks cadeau {count}',
    daily_reward_paid: 'Dagelijkse creditbeloning {count}',
    daily_reward_unpaid_short: 'VIP {count}/dag',
    daily_reward_paid_short: '{plan} {count} credits/dag',
    credits_label: 'Credits',
    vip_daily_credits_label: 'Dagelijkse beloning',
    plan_daily_credits_label: '{plan} + dagelijkse beloning',
    usage_details: 'Gebruiksdetails',
  },
}
